// extracted by mini-css-extract-plugin
export default {"cta":"dG-z","disabled":"eG-z"};